import { render } from "./SceneObjsEditor.vue?vue&type=template&id=7058aa92&scoped=true"
import script from "./SceneObjsEditor.vue?vue&type=script&lang=js"
export * from "./SceneObjsEditor.vue?vue&type=script&lang=js"

import "./SceneObjsEditor.vue?vue&type=style&index=0&id=7058aa92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7058aa92"]])

export default __exports__